import { getTitleContent } from "../utils/dataUtils";
var ShelfTitle = function (shelf) {
    var shelfTitle = document.createElement("div");
    shelfTitle.className = "list-title";
    shelfTitle.innerHTML = "<h2>".concat(getTitleContent(shelf.set.text.title.full), "</h2>");
    return shelfTitle;
};
export default ShelfTitle;
